export const enum WebhookEntity {
    ORDER = 'ORDER',
}

export type WebhookSubscription = {
    _id: string;
    organization: string;
    name: string;
    url: string;
    entities: WebhookEntity[];
    active: boolean;
    lastSuccessAt?: string;
    lastFailureAt?: string;
    lastError?: string;
    failureCount: number;
    secretLastRotatedAt: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
};

export type WebhookSubscriptionWithSecret = {
    subscription: WebhookSubscription;
    secret: string;
};

export type CreateWebhookSubscriptionInput = {
    organization: string;
    name: string;
    url: string;
    entities: WebhookEntity[];
};
